import React from 'react';
import App from '../App/App';
import { graphql, useStaticQuery } from 'gatsby';

function Apps() {
  const { apps: { nodes } } = useStaticQuery(graphql`
  query MetaDataUsingStatic {
    apps: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___id}) {
      nodes {
        frontmatter {
          id
          name
          link
          image {
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
        html
      }
    }
  }`);

  return (
    <div >
      {nodes.map(app => {
        const { frontmatter: { name, link, image, id }, html } = app;
        return <App
          key={id}
          name={name}
          desc={html}
          odd={Boolean(id % 2)}
          image={image}
          link={link}
        />;
      })}
    </div>
  )
}

export default Apps;